import React from "react";
import { UnauthenticatedPage } from 'pages/layouts';
import { FailurePanel } from 'components/notifications';

export function PaymentFailedPage() {
    return (
        <UnauthenticatedPage>
            <FailurePanel title="Payment Failed">
                <p>Your payment did not complete. Please try again using the link from your original email.</p>
            </FailurePanel>
        </UnauthenticatedPage>
    );
}
